<template>
  <div class="meals" :class="{filtered: filtersActive }">
    <FilterBar />
    <div class="meals__results">
      <MealItem v-for="meal in sortedMeals" :meal="meal" :key="meal.ID" />
      <div class="no-results" v-if="this.$store.state.Meals.searching && this.filteredMeals.length == 0">
        <img src="../assets/no-results.svg" alt="">
        <p>No results found</p>
      </div>
    </div>
  </div>
</template>

<script>
import mealsData from '../data/meals.json'
import FilterBar from '@/components/FilterBar'
import MealItem from '@/components/MealItem'

export default {
  name: 'MealList',
  components: {
    FilterBar,
    MealItem
  },
  data() {
    return {

    }
  },
  computed: {
    region() {
      return this.$store.state.Region.region
    },
    meals() {
      return mealsData[this.region]
    },
    filteredSearchTerm() {
      return this.$store.state.Meals.filterSearchTerm
    },
    dietType() {
      return this.$store.state.Meals.diets
    },
    mealType() {
      return this.$store.state.Meals.meals
    },
    filtersActive() {
      if(this.$store.state.Meals.searching) {
        return false
      } else if (this.dietType != 'All' || this.mealType != 'All') {
          return true
      }
      return false
    },
    vegetarian() {
      return this.dietType == 'Vegetarian' ? 'Y' : 'N'
    },
    vegan() {
      return this.dietType == 'Vegan' ? 'Y' : 'N'
    },
    sortBy() {
      return this.$store.state.Meals.sortBy
    },
    sortingProperty() {
      return this.sortBy === 'Alphabetical' ? 'Meal' : 'Weighted Impact'
    },
    filteredMeals() {
      const searchTerm = this.filteredSearchTerm.toLowerCase()
      const mealTerm = this.mealType.toLowerCase()
      // if (searchTerm == '') { return this.meals }
      // const searchRegex = new RegExp(`${searchTerm}`)

      if (this.$store.state.Meals.searching) {
        return this.meals.filter(meals => {
          return meals.Meal.toLowerCase().includes(searchTerm)
        })
      }

      if (this.dietType !== 'All' && this.mealType !== 'All') {
        if (this.dietType == 'Vegetarian') {
          return this.vegetarianMeals.filter(meals => meals['Meal Type (Breakfast/Lunch/Dinner)'].toLowerCase().includes(mealTerm))
        } else if(this.dietType == 'Vegan') {
          return this.veganMeals.filter(meals => meals['Meal Type (Breakfast/Lunch/Dinner)'].toLowerCase().includes(mealTerm))
        }
      } else if (this.dietType == 'Vegetarian' && this.mealType == 'All') {
        return this.vegetarianMeals
      } else if (this.dietType == 'Vegan' && this.mealType == 'All') {
        return this.vegetarianMeals
      } else if (this.dietType == 'All' && this.mealType !== 'All') {
        return this.meals.filter(meals => meals['Meal Type (Breakfast/Lunch/Dinner)'].toLowerCase().includes(mealTerm))
      }
      return this.meals
    },
    sortedMeals() {
      if (this.sortBy === 'Impact-low-high') {
        return this.filteredMeals.slice().sort((a, b) => a['Weighted Impact'] - b['Weighted Impact']) // Good meals first
      }
      if (this.sortBy === 'Impact-high-low') {
        return this.filteredMeals.slice().sort((a, b) => b['Weighted Impact'] - a['Weighted Impact']) // Bad meals first
      } else {
        // Alphabetical
        return this.filteredMeals.slice().sort((a, b) => {
          var nameA = a.Meal.toLowerCase()
          var nameB = b.Meal.toLowerCase()
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }
          return 0
        })
      }
    },
    veganMeals() {
      return this.meals.filter(meals => meals['Vegan Y/N'].toLowerCase().includes('y'))
    },
    vegetarianMeals() {
      return this.meals.filter(meals => meals['Vegetarian Y/N'].toLowerCase().includes('y'))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../assets/styles/vars';
  .meals {
    background: $cWhite;
    transition: all 1s ease-out;
    width: 100%;
    padding-top: 0;
    @media (min-width: 768px) {
      // padding-top: 80px;
      &.filtered {
        // padding-top: 140px;
      }
    }
    &.shown {
      position: relative;
    }
    &__results {
      min-height: 100vh;
      width: 100%;
      position: relative;
    }
    .no-results {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      // position: relative;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      p {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-family: $fPrimary;
        font-weight: $fwMed;
        font-size: 16px;
        line-height: 20px;
        color: #6B737B;
      }
    }
  }
</style>
